export const DOMAIN_IMAGE_URL = 'https://nhatky.aztrace.vn/upload/';
